import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { checkTokens } from './guard.functions';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store,
    private api: ApiService
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return checkTokens(
      'login',
      this.store,
      this.api,
      this.router,
      next.queryParams
    );
  }
}
